<div id="settings-address-book-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH ALPHABET FILTER AND ADDRESS-BOOK-ENTRY LIST -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <div class="row no-gutters mb-3">
                        <button id="{{idPrefix}}btn.create_new"
                                mat-flat-button color="accent"
                                class="full-width"
                                (click)="createNewAddressBookEntry()"
                                [disabled]="disabled || massDeleteActive">
                            {{ 'address_book_management.btn.create' | translate | uppercase }}
                        </button>
                    </div>

                    <div class="row no-gutters">
                        <mat-form-field class="full-width">
                            <mat-label>{{ 'common.label.search' | translate }}</mat-label>
                            <input id="{{idPrefix}}filter.input_text.searchText"
                                   type="text" matInput
                                   [(ngModel)]="filter.searchText"
                                   (blur)="fetchAddressBookEntryList()">
                            <button id="{{idPrefix}}filter.btn.clear_searchText"
                                    mat-button
                                    matSuffix mat-icon-button
                                    aria-label="'common.label.search' | translate"
                                    *ngIf="filter.searchText"
                                    (click)="clearSearchAndFetch()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-8">
                            <mat-form-field class="full-width">

                                <mat-select id="{{idPrefix}}filter.input_select.address_property"
                                            [(ngModel)]="selectedAddressFilterProperty"
                                            [disabled]="disabled"
                                            (change)="fetchAddressBookEntryList()">
                                    <mat-option *ngFor="let addressProp of addressFilterProperties"
                                                id="{{idPrefix}}filter.input_select.address_property.{{addressProp.key}}"
                                                [value]="addressProp">
                                        {{ addressProp.trans | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-4 starts-with">
                            <span>{{ 'common.label.starts_with' | translate }}</span>
                        </div>
                    </div>

                    <alphabet-search [(letter)]="filter.letter" [idPrefix]="idPrefix + 'filter.'"></alphabet-search>

                    <div class="row no-gutters address-info-container">
                        <div class="col-sm-6">
                            <span>
                                {{ 'address_book_management.info_address_count' | translate }}:
                                {{ list ? list.row_count : 0 }}
                            </span>
                        </div>

                        <div class="col-sm-6">
                            <i id="{{idPrefix}}btn.mass_delete_activate"
                               class="dr-fa-icon fas fa-user-times mass-delete-btn"
                               *ngIf="!massDeleteActive"
                               (click)="toggleMassDelete()"
                               [matTooltip]="'address_book_management.mass_delete.activate' | translate"></i>
                            <i id="{{idPrefix}}.btn.mass_delete_deactivate"
                               class="dr-fa-icon fas fa-user-times mass-delete-btn active"
                               *ngIf="massDeleteActive"
                               (click)="toggleMassDelete()"
                               [matTooltip]="'address_book_management.mass_delete.deactivate' | translate"></i>
                        </div>
                    </div>

                    <!-- Below template is passed on to the action list to replace the default appearance -->
                    <ng-template #customActionListTemplate
                                 let-addressBookEntry="data">
                        <span class="action-list-display-name" [ngClass]="{'will-be-deleted': selectedForDeletion(addressBookEntry) }">
                             <i class="fas fa-trash-alt"></i> {{ addressBookEntry.actionListDisplayName | translate }}
                        </span>

                    </ng-template>

                    <!-- MASS DELETE LIST -->

                    <action-list *ngIf="filter.filteredArray && massDeleteActive"
                                 [items]="filter.filteredArray"
                                 [template]="customActionListTemplate"
                                 [idPrefix]="idPrefix"
                                 (select)="selectAddressBookEntry($event)">
                    </action-list>

                    <!-- REGULAR RESULT LIST -->

                    <action-list *ngIf="filter.filteredArray && !massDeleteActive"
                                 [items]="filter.filteredArray"
                                 [selected]="selected"
                                 [options]="actionListOptions"
                                 [idPrefix]="idPrefix"
                                 (select)="selectAddressBookEntry($event)"
                                 (delete)="deleteAddressBookEntry($event)">
                    </action-list>

                    <div *ngIf="list && list.items && list.items.length === 0"
                          class="info-no-results">
                        {{ 'address_book_management.info_no_results' | translate}}
                    </div>

                    <div class="row mt-5" *ngIf="massDeleteActive">

                        <div class="col-xs-12 col-md-6">
                            <a id="{{idPrefix}}mass_delete.btn.cancel"
                               mat-stroked-button
                               color="primary"
                               class="full-width"
                               (click)="toggleMassDelete()">
                                {{ 'common.btn.cancel' | translate | uppercase }}
                            </a>
                        </div>

                        <div class="col-xs-12 col-md-6">
                            <button id="{{idPrefix}}mass_delete.btn.confirm"
                                    mat-flat-button
                                    color="accent"
                                    class="full-width"
                                    (click)="confirmMassDelete()"
                                    [disabled]="disabled || addressesToMassDelete.length === 0">
                                {{ 'address_book_management.btn.mass_delete_addresses' | translate | uppercase }}
                            </button>
                        </div>

                    </div>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED USER -->


        <div class="col-sm-12 col-md-8">

            <mat-card>
                <mat-card-content>

                    <address-book-entry *ngIf="selected"
                                        [(bananaBox)]="selected"
                                        (bananaBoxChange)="updateInList()"
                                        (canceled)="cancel()"
                                        [idPrefix]="idPrefix">
                    </address-book-entry>

                </mat-card-content>
            </mat-card>

        </div>

    </div>
</div>
